export enum AdditionalServiceReferenceTypes {
  Unknown = 0,
  WrittenDevelopmentFeedback = 1,
  VerbalDevelopmentFeedback = 2,
  viaEdgeAssessment = 3
}

